import React from 'react';
import { companyInfo, navigationLinks } from '../data/mock';
import { MapPin, Phone, Mail, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="relative bg-[#0f1d30] text-white grain-dark">
      {/* Main Footer */}
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-8">
          
          {/* Brand Column */}
          <div className="lg:col-span-5 space-y-5">
            <img 
              src="/images/logo.svg" 
              alt="Mainet Makelaars"
              className="h-12 w-auto"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p className="text-slate-400 leading-[1.75] max-w-sm text-sm">
              Specialized risk management for complex portfolios and commercial ventures. 
              We structure comprehensive defense around your wealth and operations.
            </p>
            <div className="flex items-center gap-3 pt-2">
              <div className="w-8 h-[1.5px] bg-[#10b981]" />
              <span className="text-[10px] tracking-[0.18em] text-slate-500 uppercase font-medium">
                Since 1996
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-3 lg:pl-8">
            <h4 className="text-[10px] tracking-[0.2em] uppercase font-semibold text-slate-500 mb-5">
              Navigation
            </h4>
            <nav className="flex flex-col gap-2.5">
              {navigationLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  className="text-sm text-slate-400 hover:text-white transition-colors duration-300 flex items-center group w-fit"
                >
                  {link.label}
                  <ArrowUpRight className="ml-1 h-3 w-3 opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <h4 className="text-[10px] tracking-[0.2em] uppercase font-semibold text-slate-500 mb-5">
              Contact
            </h4>
            <div className="space-y-3.5">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-start gap-3 text-sm text-slate-400 hover:text-white transition-colors duration-300 group"
              >
                <Phone size={16} className="mt-0.5 text-[#10b981] flex-shrink-0" />
                <span>{companyInfo.phone}</span>
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-start gap-3 text-sm text-slate-400 hover:text-white transition-colors duration-300 group"
              >
                <Mail size={16} className="mt-0.5 text-[#10b981] flex-shrink-0" />
                <span>{companyInfo.email}</span>
              </a>
              <div className="flex items-start gap-3 text-sm text-slate-400">
                <MapPin size={16} className="mt-0.5 text-[#10b981] flex-shrink-0" />
                <span>{companyInfo.address}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <p className="text-xs text-slate-500">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-xs text-slate-500 text-center sm:text-right">
              {companyInfo.regulatory}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
